import { z } from 'zod';
import { JobStatusSchema } from './sync.js';

export const JobSubjectKindSchema = z.enum(['profile', 'timeline', 'arena']);
export const JobTypeSchema = z.enum(['profileTweetsIngest', 'profileAnalysis', 'timelineAnalysis', 'arenaAnalysis']);

export const JobEnsureTypeSchema = z.enum(['profileTweetsIngest', 'profileAnalysis', 'timelineAnalysis']);
export const JobEnsureSubjectKindSchema = z.enum(['profile', 'timeline']);

export const JobMetadataSchema = z.record(z.string(), z.unknown());

export const JobEntitySchema = z.object({
  id: z.string(),
  jobType: JobTypeSchema,
  subjectKind: JobSubjectKindSchema,
  subjectId: z.string(),
  status: JobStatusSchema,
  progressCount: z.number().int().nonnegative(),
  estimatedTotal: z.number().int().nonnegative(),
  heartbeatAt: z.string().nullable(),
  startedAt: z.string().nullable(),
  finishedAt: z.string().nullable(),
  updatedAt: z.string().nullable(),
  lastError: z.string().nullable(),
  metadata: JobMetadataSchema,
});

export const JobStatusResponseSchema = z.discriminatedUnion('exists', [
  z.object({ exists: z.literal(false) }),
  z.object({
    exists: z.literal(true),
    percent: z.number(),
    job: JobEntitySchema,
  }),
]);

export const JobStatusQuerySchema = z.object({
  jobType: JobTypeSchema,
  subjectKind: JobSubjectKindSchema,
  subjectId: z.string().min(1),
});

export const JobEnsureRequestSchema = z.object({
  jobType: JobEnsureTypeSchema,
  subjectKind: JobEnsureSubjectKindSchema,
  subjectId: z.string().min(1),
  estimatedTotal: z.number().int().min(1).max(5000).optional(),
  metadata: JobMetadataSchema.optional(),
});

export const JobEnsureResponseSchema = JobEntitySchema;

export type JobSubjectKind = z.infer<typeof JobSubjectKindSchema>;
export type JobType = z.infer<typeof JobTypeSchema>;
export type JobEnsureType = z.infer<typeof JobEnsureTypeSchema>;
export type JobEnsureSubjectKind = z.infer<typeof JobEnsureSubjectKindSchema>;
export type JobStatusResponse = z.infer<typeof JobStatusResponseSchema>;
export type JobEnsureRequest = z.infer<typeof JobEnsureRequestSchema>;
export type JobEnsureResponse = z.infer<typeof JobEnsureResponseSchema>;
